/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import foundationColors from './color-foundation-tokens';
import primitiveColors from '../../tokens/color-primitive-tokens';
import getSemanticColors from './color-semantic-tokens';
import getComponentColors from './color-component-tokens';
import borders from './borders';
import lighting from '../shared/lighting';
import typography, { v1TypographyBaseline } from '../shared/typography';
import animation from '../shared/animation';
import breakpoints from '../shared/breakpoints';
import grid from '../shared/grid';
import mediaQuery from '../shared/media-query';
import sizing from '../shared/sizing';
import elevationTokens from '../../tokens/elevation-tokens';
import cornerRadiusTokens from '../../tokens/corner-radius-tokens';
import type { Theme } from '../../styles/types';
export const DarkTheme: Theme = {
  name: 'dark-theme',
  themeMode: 'dark',
  colors: {
    ...foundationColors,
    ...primitiveColors,
    ...getComponentColors(),
    ...getSemanticColors()
  },
  elevation: {
    ...elevationTokens
  },
  cornerRadius: {
    ...cornerRadiusTokens
  },
  animation,
  breakpoints,
  borders,
  direction: 'auto',
  grid,
  lighting,
  mediaQuery,
  sizing,
  typography,
  // Independent per-Font clone — must never share Font object references with
  // `typography` above, otherwise in-place mutation from `deepMerge`
  // (`createDarkTheme(overrides)`) would corrupt this baseline too and
  // break override detection in `useThemeWithPotentialUpgrades`.
  v1Typography: v1TypographyBaseline,
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2000
  }
};